import { batteryPricingBundle } from "./battery-pricing-bundle"
import { PricingWarrantyStep } from "../../ProposalSetup/pricing/PricingWarrantyStep"

export const WarrantyStep = ({
  proposalId,
  onClose,
}: {
  proposalId: string
  onClose: () => void
}): JSX.Element => (
  <PricingWarrantyStep
    kind={batteryPricingBundle}
    proposalId={proposalId}
    onClose={onClose}
  />
)
